// Copyright (c) 2017 Deere & Company

import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updatePipCodeRequestItemToUpdate = (state, action) =>
    PipCode.update(state, {
        $set: action.item
    });

const updatePipCodeRequestTcsmComments = (state, action) =>
    PipCode.update(state, {
        tcsmComments: {
            $set: action.comments
        }
    });

export default (state = getDefaultState().pipCodeRequestItemToUpdate, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_PIP_CODE_REQUEST_ITEM_TO_UPDATE]: updatePipCodeRequestItemToUpdate,
        [actions.UPDATE_TCSM_PIP_CODE_REQUEST_TCSM_COMMENTS]: updatePipCodeRequestTcsmComments
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/pip-code-request-item-to-update.js